import { NgModule } from '@angular/core';
import { PlSlicePipe } from './plSlice.pipe';

@NgModule({
  declarations: [PlSlicePipe],
  exports: [PlSlicePipe],
})
export class PlSlicePipeModule {}
